import { composeIO } from 'react-compose-io'
import { tabelaControleComissaoPedidoIO } from './TabelaControleComissaoPedido.IO'
import { TabelaControleComissaoPedidoView } from './TabelaControleComissaoPedido.View'

export const TabelaControleComissaoPedido = composeIO(TabelaControleComissaoPedidoView, tabelaControleComissaoPedidoIO)
